export function getPropKeyValues<P>(props: { [key: string]: any }, keys: string[]): { [key: string]: any } {
  return keys.reduce<{ [key: string]: any }>((prev, curr) => {
    if (props.hasOwnProperty(curr)) {
      prev[curr] = props[curr];
    }
    return prev;
  }, {});
}
